export default __webpack_public_path__ + "static/login-backgrounds-2c2922429b73afe20aa7bbfcfc40269b.jpg";